<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
function updateCartCount() {
    fetch('/cart.js') // Get the latest cart data
        .then(response => response.json())
        .then(data => {
            let itemCount = data.item_count; // Get total cart item count
            let cartBubble = document.querySelector('.cart-count-bubble');

            if (cartBubble) {
                cartBubble.textContent = itemCount; // Update the count
                cartBubble.style.display = itemCount > 0 ? 'block' : 'none'; // Show/hide bubble
            }
        })
        .catch(error => console.error('Error updating cart count:', error));
}

// Run the function every 5 seconds
setInterval(updateCartCount, 5000);

// Call it once on page load
updateCartCount();